<template>
  <v-content>
    <template v-if="download">
      <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
        <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="value"
            color="yellow"
        >
          {{ value }}
        </v-progress-circular>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckPermiss">
        <template v-if="Project.length > 0">
          <template
              v-if="(Project[0].Approve == '1' && (Project[0].Project_type == '1' || (Project[0].Project_type == '2' && (Project[0].IsProcess == '1' || Project[0].IsProcess == '3'))))">
            <template
                v-if="ApproveMaster.filter(item => (item.type == '1' && (Project[0].Project_category == '1')) || (item.type == '2' && (Project[0].Project_category == '2' || Project[0].Project_category == '3' || Project[0].Project_category == '4'))).length > 0 && ((Project[0].Project_type == '1' && checkProj1) || (Project[0].Project_type == '2' && checkProj2))">
              <v-card>
                <v-toolbar color="yellow" class="d-flex justify-center">
                  <v-toolbar-title class="font-weight-bold">
                    <span v-if="Project.length > 0">{{ Project[0].Project_name }}</span>
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-list>
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="8">
                          <v-card>
                            <v-card-title style="background-color: #ff6d81">
                   <span style="color: white">
                     ละเอียดข้อมูลแผน
                   </span>
                            </v-card-title>
                            <v-card-text>
                              <v-tabs
                                  v-model="tab"
                                  background-color="transparent"
                                  color="basil"
                                  grow
                              >
                                <v-tab
                                    key="planOld"
                                >
                                  <span style="font-weight: bold;color: #364eff">ข้อมูลแผน (ใหม่)</span>
                                </v-tab>
                                <v-tab
                                    key="planNew"
                                >
                                  <span style="font-weight: bold;color: red">ข้อมูลแผน (เดิม)</span>
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="tab">
                                <v-tab-item
                                    key="planOld"
                                >
                                  <template>
                                    <v-list v-if="TempProject.length > 0">
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">กลุ่มโครงการ (โครงการ, อบรม/เดินทางไปปฏิบัติราชการ)</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span v-if="TempProject[0].Project_type == '1'" style="font-weight: bold;color: #364eff">โครงการ</span>
                                            <span v-else style="font-weight: bold;color: green">อบรม / เดินทางไปปฏิบัติราชการ</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">รหัสแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].Project_code }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ชื่อแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].Project_name }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">แผนประจำปีประจำปี</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ parseInt(TempProject[0].FiscalYear) + 543 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold"
                                                   v-if="TempProject[0].FiscalYear != '' && TempProject[0].Project_type == '2'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทการทำรายการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   TempProject[0].IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : TempProject[0].IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หมวดโครงการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   TempProject[0].Project_category == '1' ? 'พัฒนาบุคลากร' : TempProject[0].Project_category == '2' ? 'โครงการอื่นๆ' : TempProject[0].Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   Project[0].IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ระยะเวลาที่คาดว่าจะจัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                 <span v-if="episode == '1'">{{
                                     'ต.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1)
                                   }}</span>
                                            <span v-if="episode == '2'">{{
                                                'ม.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มี.ค. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '3'">{{
                                                'เม.ย. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '4'">{{
                                                'ก.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- ก.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '9'">{{
                                                'ตลอดปีงบประมาณ ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   projectGroup.filter(item => item.Project_group == TempProject[0].Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == TempProject[0].Project_group)[0].Project_group_des : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หลักสูตร</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == TempProject[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject[0].Course_code)[0].Course_name : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">สาขาประเภทหลักสูตร</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == TempProject[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject[0].Course_code)[0].Course_type_des : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ระยะเวลา</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == TempProject[0].Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject[0].Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject[0].Course_code)[0].Period_code)[0].name : '-' : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งาน / กิจกรรม ถูกจัดขึ้น</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   PLACESelete.filter(item => item.id == TempProject[0].PLACE).length > 0 ? PLACESelete.filter(item => item.id == TempProject[0].PLACE)[0].detail : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="TempProject[0].PLACE == '2'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จังหวัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   provinces_Data.filter(item => item.code == TempProject[0].Province_id).length > 0 ? provinces_Data.filter(item => item.code == TempProject[0].Province_id)[0].name_th : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="TempProject[0].PLACE == '3'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเทศ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   countryData.filter(item => item.ct_code == TempProject[0].Country_id).length > 0 ? countryData.filter(item => item.ct_code == TempProject[0].Country_id)[0].ct_nameTHA : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จัดโดย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   WorkByData.filter(item => item.id == TempProject[0].WorkBy).length > 0 ? WorkByData.filter(item => item.id == TempProject[0].WorkBy)[0].detail : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หน่วยงานที่รับผิดชอบโครงการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                   <span>{{
                                       depart.filter(item => item.dep_id == TempProject[0].Dep_Code)[0].dep_name
                                     }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ชื่อผู้จัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].WorkByName }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">เบอร์โทรติดต่อผู้กรอกข้อมูล</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].WorkByPhone }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">สถานที่จัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].Location }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งบประมาณที่ขอ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].BudgetRequest | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="TempProject[0].IsPlanStatus == '6'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งบประมาณที่อนุมัติ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].BudgetArrove | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="TempProject[0].IsPlanStatus == '6'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จำนวนเงินเบิกจ่าย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].MoneyDisburse | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จำนวน ช.ม.</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].CalHourse }} ช.ม.</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">กลุ่มเป้าหมาย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].TargetGroup }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">วัตถุประสงค์</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].Objective }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">รายละเอียดเพิ่มเติมประกอบ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ TempProject[0].Remarks }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span
                                                style="color: #ff6d81">Competency,Core Value,Strategic Objective</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <v-btn text color="primary" @click="showTempCompetency(TempProject[0])">
                                              คลิก!!
                                            </v-btn>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ไฟล์เอกสารประกอบ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <v-btn text color="primary" @click="showTempFile(TempProject[0])">คลิก!!
                                            </v-btn>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                    </v-list>
                                  </template>
                                </v-tab-item>
                                <v-tab-item
                                    key="planNew"
                                >
                                  <template>
                                    <v-list v-if="Project.length > 0">
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">กลุ่มโครงการ (โครงการ, อบรม/เดินทางไปปฏิบัติราชการ)</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                          <span>{{
                                              (Project[0].Project_type == '1' ? 'โครงการ' : 'อบรม / เดินทางไปปฏิบัติราชการ')
                                            }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">รหัสแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].Project_code }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ชื่อแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].Project_name }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">แผนประจำปีประจำปี</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ parseInt(Project[0].FiscalYear) + 543 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold"
                                                   v-if="Project[0].FiscalYear != '' && Project[0].Project_type == '2'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทการทำรายการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   Project[0].IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : Project[0].IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หมวดโครงการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   Project[0].Project_category == '1' ? 'พัฒนาบุคลากร' : Project[0].Project_category == '2' ? 'โครงการอื่นๆ' : Project[0].Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   Project[0].IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ระยะเวลาที่คาดว่าจะจัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                 <span v-if="episode == '1'">{{
                                     'ต.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1)
                                   }}</span>
                                            <span v-if="episode == '2'">{{
                                                'ม.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มี.ค. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '3'">{{
                                                'เม.ย. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '4'">{{
                                                'ก.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- ก.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                            <span v-if="episode == '9'">{{
                                                'ตลอดปีงบประมาณ ' + (parseInt(Project[0].FiscalYear) + 543)
                                              }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเภทแผน</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   projectGroup.filter(item => item.Project_group == Project[0].Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project[0].Project_group)[0].Project_group_des : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หลักสูตร</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Course_name : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">สาขาประเภทหลักสูตร</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Course_type_des : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ระยะเวลา</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Period_code)[0].name : '-' : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งาน / กิจกรรม ถูกจัดขึ้น</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   PLACESelete.filter(item => item.id == Project[0].PLACE).length > 0 ? PLACESelete.filter(item => item.id == Project[0].PLACE)[0].detail : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="Project[0].PLACE == '2'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จังหวัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   provinces_Data.filter(item => item.code == Project[0].Province_id).length > 0 ? provinces_Data.filter(item => item.code == Project[0].Province_id)[0].name_th : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="Project[0].PLACE == '3'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ประเทศ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   countryData.filter(item => item.ct_code == Project[0].Country_id).length > 0 ? countryData.filter(item => item.ct_code == Project[0].Country_id)[0].ct_nameTHA : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จัดโดย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                               <span>{{
                                   WorkByData.filter(item => item.id == Project[0].WorkBy).length > 0 ? WorkByData.filter(item => item.id == Project[0].WorkBy)[0].detail : '-'
                                 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">หน่วยงานที่รับผิดชอบโครงการ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                   <span>{{
                                       depart.filter(item => item.dep_id == Project[0].Dep_Code)[0].dep_name
                                     }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ชื่อผู้จัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].WorkByName }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">เบอร์โทรติดต่อผู้กรอกข้อมูล</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].WorkByPhone }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">สถานที่จัด</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].Location }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งบประมาณที่ขอ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].BudgetRequest | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="Project[0].IsPlanStatus == '6'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">งบประมาณที่อนุมัติ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].BudgetArrove | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold" v-if="Project[0].IsPlanStatus == '6'">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จำนวนเงินเบิกจ่าย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].MoneyDisburse | currency }}</span> บาท
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">จำนวน ช.ม.</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].CalHourse }} ช.ม.</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">กลุ่มเป้าหมาย</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].TargetGroup }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">วัตถุประสงค์</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].Objective }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">รายละเอียดเพิ่มเติมประกอบ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span>{{ Project[0].Remarks }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span
                                                style="color: #ff6d81">Competency,Core Value,Strategic Objective</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <v-btn text color="primary" @click="showCompetency(Project[0])">คลิก!!
                                            </v-btn>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="font-weight-bold">
                                        <v-row>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <span style="color: #ff6d81">ไฟล์เอกสารประกอบ</span>
                                          </v-col>
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-divider></v-divider>
                                      <p class="mt-8" style="font-weight: bold">วันที่บันทึกข้อมูลแผน:
                                        {{ Project[0].Create_Time | dateToThai2 }}</p>
                                      <p style="font-weight: bold">สถานะแผน:
                                        <v-chip
                                            v-if="StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0"
                                            :color="StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus)[0].color : ''"
                                            style="transform: scale(0.8);color: white"
                                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus)[0].status : ''
                              }}</span>
                                        </v-chip>
                                      </p>
                                      <hr class="mb-2 mt-2"/>
                                      <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px"
                                            v-if="parseInt(Project[0].IsPlanStatus) >= 6 && parseInt(Project[0].IsPlanStatus) <= 9">
                                อนุมัติวงเงิน : {{ TempProject[0].BudgetArrove | currency }} บาท
                              </span>
                                      <hr class="mb-2 mt-2"/>
                                      <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px"
                                            v-if="parseInt(Project[0].IsPlanStatus) >= 6 && parseInt(Project[0].IsPlanStatus) <= 9">
                                จำนวนเงินเบิกจ่าย : {{ TempProject[0].MoneyDisburse | currency }} บาท
                              </span>
                                    </v-list>
                                  </template>
                                </v-tab-item>
                              </v-tabs-items>
                              <div>
                                <v-divider></v-divider>
                                <v-list-item v-if="TempProject.length > 0">
                                  <v-alert outlined style="width: 100%" class="text-center"
                                           v-if="TempStatusProject.filter(staItem => staItem.id == TempProject[0].Req_status).length > 0"
                                           :color="TempStatusProject.filter(staItem => staItem.id == TempProject[0].Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == TempProject[0].Req_status)[0].color : ''">
                         <span>
                       {{
                             TempStatusProject.filter(staItem => staItem.id == TempProject[0].Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == TempProject[0].Req_status)[0].status : ''
                           }}
                         </span>
                                  </v-alert>
                                </v-list-item>
                                <v-divider></v-divider>
                                <template v-if="TempProject.length > 0">
                                  <template
                                      v-if="((inspector && inspector_ro && TempProject[0].Req_status == '0') || (Master && Master_ro && TempProject[0].Req_status == '3') || (Manager && Manager_ro && TempProject[0].Req_status == '4') || (Owner && Owner_ro))">
                                    <v-card class="mt-6">
                                      <v-card-title
                                          :style="(inspector && TempProject[0].Req_status == '0') ? 'background-color: cornflowerblue' : (Master && TempProject[0].Req_status == '3') ? 'background-color: cadetblue' : (Manager && TempProject[0].Req_status == '4') ? 'background-color: darkgreen' : 'background-color: black'">
                         <span style="color: white">
                           {{
                             (inspector && TempProject[0].Req_status == '0') ? 'พิจารณาแผน (โดยผู้มีอำนาจหรือผู้ปฏิบัติหน้าที่แทน)' : (Master && TempProject[0].Req_status == '3') ? 'พิจารณาอนุมัติแผน (ขั้นต้น)' : (Manager && TempProject[0].Req_status == '4') ? 'พิจารณาโดยผู้มีอำนาจอนุมัติ (รองคณบดีหรือผู้ได้รับมอบหมายปฏิบัติหน้าที่แทน)' : ''
                           }}
                         </span>
                                      </v-card-title>
                                      <v-card-text>
                                        <template v-if="Req_Approve_Status.filter(item => !item.disable).length > 0">
                                          <v-list-item class="justify-center" style="margin-top: 30px">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-autocomplete
                                                    outlined
                                                    v-model="Approve_m"
                                                    label="ผลการพิจารณา"
                                                    :items="Req_Approve_Status"
                                                    item-text="detail"
                                                    item-value="id"
                                                    :error-messages="Approve_m == '' ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                                    persistent-hint
                                                    :error="Approve_m == ''"
                                                >
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <!--                    <v-list-item class="justify-center" v-if="Approve_m == '0'">
                                                                <v-row class="d-flex justify-center">
                                                                  &lt;!&ndash;                              <v-col&ndash;&gt;
                                                                  &lt;!&ndash;                                  cols="12"&ndash;&gt;
                                                                  &lt;!&ndash;                                  md="4">&ndash;&gt;
                                                                  &lt;!&ndash;                                <v-text-field&ndash;&gt;
                                                                  &lt;!&ndash;                                    v-model="App_doc_no"&ndash;&gt;
                                                                  &lt;!&ndash;                                    outlined&ndash;&gt;
                                                                  &lt;!&ndash;                                    label="หนังสือเลขที่อนุมัติหลักการ"&ndash;&gt;
                                                                  &lt;!&ndash;                                >&ndash;&gt;
                                                                  &lt;!&ndash;                                </v-text-field>&ndash;&gt;
                                                                  &lt;!&ndash;                              </v-col>&ndash;&gt;
                                                                  <v-col
                                                                      cols="12"
                                                                      md="8">
                                                                    <v-text-field
                                                                        v-model="BudgetArrove"
                                                                        outlined
                                                                        label="จำนวนเงินที่อนุมัติ"
                                                                    >
                                                                    </v-text-field>
                                                                  </v-col>
                                                                </v-row>
                                                              </v-list-item>-->
                                          <v-list-item class="justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-textarea
                                                    v-model="remarksApprove"
                                                    outlined
                                                    label="เหตุผล"
                                                >
                                                </v-textarea>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  class="d-flex justify-center"
                                                  cols="6"
                                                  md="3">
                                                <v-btn
                                                    style="height: 55px"
                                                    outlined
                                                    color="primary"
                                                    @click="Approve_m == '3' ? ChooseMasterApprove('2') : Approve_m == '4' ?ChooseMasterApprove('3')  : ConsideReqEditProject(false)"
                                                    :disabled="btnDisable"
                                                >
                                                  บันทึก
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </template>
                                        <template v-else>
                                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                            คุณไม่ได้รับสิทธิ์ในการพิจารณาแผนตั้งงบประมาณประจำปี !!</p>
                                        </template>
                                        <v-list-item class="justify-center">
                                          <v-row justify="center">
                                            <v-col
                                                cols="12"
                                                md="12">
                                              <span style="font-weight: bold">ประวัติการพิจารณาแผน</span>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <template v-if="TempRecordData.length > 0">
                                          <v-list-item class="justify-center">
                                            <v-row justify="center">
                                              <v-col
                                                  cols="12"
                                                  md="12">
                                                <v-list-item>
                                                  <v-expansion-panels popout>
                                                    <v-expansion-panel
                                                        v-for="(item,i) in TempRecordData"
                                                        :key="i"
                                                    >
                                                      <v-expansion-panel-header>
                                                        ประวัติการพิจารณาแผน
                                                        วันที่พิจารณา
                                                        <span
                                                            style="color: #364eff;margin-left: 15px">{{
                                                            item.Create_Time | dateToThai2
                                                          }}</span>
                                                        สถานะ :
                                                        <v-chip
                                                            v-if="TempStatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                            :color="TempStatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                            style="transform: scale(0.8);color: white"
                                                            class="d-flex justify-center"
                                                        >
                            <span
                                style="color: white">{{
                                TempStatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                                        </v-chip>
                                                      </v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <p>
                                                          เหตุผล : {{ item.Remark }}
                                                        </p>
                                                        <div v-for="(file,idx) in item.files"
                                                             v-bind:key="idx"
                                                             style="color: #ff6d81">
                                                          ไฟล์ประกอบ :
                                                          <v-btn text
                                                                 @click="ShowData(Openfile + file.File_path)">
                                                            {{ file.File_name }}
                                                          </v-btn>
                                                        </div>
                                                      </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                  </v-expansion-panels>
                                                </v-list-item>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </template>
                                        <template v-else>
                                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                            ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                                        </template>
                                      </v-card-text>
                                    </v-card>
                                  </template>
                                </template>
<!--                                <v-card class="mt-6"
                                        v-if="Master && (TempProject.length > 0 && TempProject[0].Req_status == '3')">
                                  <v-card-title style="background-color: cornflowerblue">
                         <span style="color: white">
                           พิจารณาอนุมัติคำร้องขอแก้ไขข้อมูลแผน (ขั้นต้น)
                         </span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-list>
                                      <v-list-item class="justify-center">
                                        <v-radio-group v-model="Approve2" row :error="Approve2 == null"
                                                       :error-messages="Approve2 == null ? '*' : ''">
                                          &lt;!&ndash;                                    <v-radio label="ไม่อนุมัติ" color="red" value="1"></v-radio>&ndash;&gt;
                                          &lt;!&ndash;                                        <v-radio label="รอพิจารณา" color="green" value="1"></v-radio>&ndash;&gt;
                                          <v-radio label="ไม่อนุมัติ" color="red" value="2"></v-radio>
                                          <v-radio label="อนุมัติ (ขั้นต้น)" color="green" value="4"></v-radio>
                                        </v-radio-group>
                                      </v-list-item>
                                      <v-list-item>
                                        <v-row class="d-flex justify-center">
                                          <v-col
                                              cols="12"
                                              md="10"
                                          >
                                            <v-textarea v-model="Remark2" outlined label="หมายเหตุ"></v-textarea>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item class="justify-center">
                                        <v-btn outlined
                                               @click="(Approve2 == '4' ? ChooseMasterApprove('3') : ApproveDataMaster())"
                                               color="green">บันทึก
                                        </v-btn>
                                      </v-list-item>
                                    </v-list>
                                  </v-card-text>
                                </v-card>
                                <template
                                    v-if="Manager && (TempProject.length > 0 && TempProject[0].Req_status == '4')">
                                  <v-card class="mt-6">
                                    <v-card-title style="background-color: cornflowerblue">
                         <span style="color: white">
                           พิจารณาโดยผู้มีอำนาจอนุมัติ (รองคณบดีหรือผู้ได้รับมอบหมายปฏิบัติหน้าที่แทน)
                         </span>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-list>
                                        <v-list-item class="justify-center">
                                          <v-radio-group v-model="Approve" row :error="Approve == null"
                                                         :error-messages="Approve == null ? '*' : ''">
                                            &lt;!&ndash;                                          <v-radio label="รอพิจารณา" color="green" value="1"></v-radio>&ndash;&gt;
                                            <v-radio label="ไม่อนุมัติ" color="red" value="2"></v-radio>
                                            <v-radio label="อนุมัติ" color="green" value="1"></v-radio>
                                          </v-radio-group>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="10"
                                            >
                                              <v-textarea v-model="Remark" outlined label="หมายเหตุ"></v-textarea>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item class="justify-center">
                                          <v-btn outlined @click="ApproveData" color="green">บันทึก</v-btn>
                                        </v-list-item>
                                      </v-list>
                                    </v-card-text>
                                  </v-card>
                                </template>-->
                              </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn dark color="red" class="text-caption text-md-h5 font-weight-bold pa-6" @click="backToMenu">กลับเมนูหลัก พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
              <template>
                <v-dialog
                    v-model="dialogTemplate"
                    scrollable
                    width="800"
                >
                  <v-card>
                    <v-card-title style="background-color: cornflowerblue;color: white">
                      ฟอร์มข้อมูลประกอบโครงการ
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-6" v-if="TemplateProject.length > 0" v-html="TemplateProject[0].Template"></div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="dialogTemplate = false" color="red">ปิด</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด คุณไม่ได้รับสิทธิ์พิจารณาแผนอนุมัติงบประมาณประจำปี</span>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด ประเภทโครงการไม่ถูกต้องในการอนุมัติโดย ผู้มีอำนาจอนุมัติ โปรดตรวจสอบโครงการอีกครั้ง !!</span>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด ไม่พบข้อมูลเสนอแผนอนุมัติงบประมาณประจำปี หรือข้อมูลแผนอาจถูกลบไปแล้ว!!</span>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">คุณไม่ได้รับสิทธิ์ในการจัดการเมนูพิจารณาคำขอแก้ไขแผนอนุมัติงบประมาณ</span>
        </div>
      </template>
    </template>
    <template>
      <v-dialog
          v-model="dialogApproveForm"
          scrollable
          width="800"
      >
        <v-card>
          <v-card-title>
            <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
          </v-card-title>
          <v-card-text v-if="ApproveForm.length > 0">
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12">
                <v-card>
                  <v-card-title class="font-weight-bold justify-center">
                    <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                  </v-card-title>
                  <v-card-text>
                    <list>
                      <v-list-item class="font-weight-bold">
                        <span style="font-size: 16px">เรียน  รองคณบดีฝ่ายทรัพยากรมนุษย์</span>
                      </v-list-item>
                      <v-list-item>
                        <span style="font-weight: bold">{{ ApproveForm[0].message }}</span>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold">{{ ApproveForm[0].name }}</span>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold">{{ ApproveForm[0].position }}</span>
                      </v-list-item>
                      <v-list-item class="font-weight-bold">
                        <v-spacer></v-spacer>
                        <span style="font-size: 16px">
                                 {{ new Date().getDate() }} / {{
                            new Date().getMonth() + 1
                          }} / {{ new Date().getFullYear() + 543 }}
                               </span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                     <span
                         style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 200px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                     <span
                         style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 80px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 120px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>


                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(................../........................./.....................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(................../........................../....................)</span>
                      </v-list-item>
                    </list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="red" @click="dialogApproveForm = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogCompetency"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            Competency,Core Value,Strategic Objective
          </v-card-title>
          <v-card-text>
            <template v-if="CompetencyToShow.length > 0">
              <v-treeview :activatable="true" :items="CompetencyToShow">
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file" color="blue lighten-2">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item, active }">
                  <div v-if="isMobile" style="cursor: pointer">
                                               <span style="font-size: 12px;color: black" v-if="!active">
                                                   {{ item.name }}
                                               </span>
                    <span style="font-size: 12px;color: #364eff;font-weight: bold"
                          v-else>
                                                   {{ item.name }}
                                               </span>
                  </div>
                  <div v-else style="cursor: pointer">
                                               <span style="color:black;" v-if="!active">
                                                   {{ item.name }}
                                               </span>
                    <span style="color: #364eff;font-weight: bold" v-else>
                                                   {{ item.name }}
                                               </span>
                  </div>
                </template>
              </v-treeview>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                Competency,Core Value,Strategic Objective</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogCompetency = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogMasterApprove"
          max-width="800">
        <v-card>
          <v-card-title>
             <span
                 style="font-width: bold;">กรุณาเลือกผู้อนุมัติลำดับถัดไป => {{
                 (Approve2 == '3' ? '(พิจารณาโดยผู้มีอำนาจอนุมัติ (ขั้นต้น))' : '(พิจารณาโดยผู้มีอำนาจอนุม้ติ)')
               }}</span>
          </v-card-title>
          <v-card-text>
            <template v-if="approveMasterChoose.length > 0">
              <v-checkbox
                  class="font-weight-bold"
                  v-model="sendApprove"
                  v-for="(approveMs, idx) in approveMasterChoose" :key="idx"
                  :label="(idx + 1) + ') ' + approveMs.custom_Detail + ' (' + approveMs.position + ')'"
                  :value="approveMs.id"
              ></v-checkbox>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลผู้มีอำนาจอนุมัติลำดับถัดไป</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold" color="primary" outlined @click="SendNextApprove"
                   v-if="approveMasterChoose.length > 0">
              ส่งต่อผู้มีอำนาจอนุมัติ
            </v-btn>
            <v-btn class="font-weight-bold" color="red" outlined @click="dialogMasterApprove = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogFile"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            ไฟล์เอกสารประกอบ
          </v-card-title>
          <v-card-text>
            <template v-if="FileProject.length > 0">
              <v-container fluid>
                <v-row>
                  <v-col
                      v-for="(file_i, index) in FileProject"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12"
                      md="4"
                  >
                    <v-card flat tile>
                      <v-img
                          v-if="file_i.type == 'image'"
                          :src="file_i.src"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                          v-if="file_i.type == 'pdf'"
                          src="../assets/Image/pdf.png"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text
                               @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogFile = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogTempFile"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            ไฟล์เอกสารประกอบ
          </v-card-title>
          <v-card-text>
            <template v-if="TempFileProject.length > 0">
              <v-container fluid>
                <v-row>
                  <v-col
                      v-for="(file_i, index) in TempFileProject"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12"
                      md="4"
                  >
                    <v-card flat tile>
                      <v-img
                          v-if="file_i.type == 'image'"
                          :src="file_i.src"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                          v-if="file_i.type == 'pdf'"
                          src="../assets/Image/pdf.png"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text
                               @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogTempFile = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>
<script>
// import axios from "axios";
// import ConstData from "@/const/Const";
import {mapActions, mapGetters} from "vuex";
import ConstData from "@/const/Const";
import jsPDF from 'jspdf'
import axios from "axios";
import queryString from "query-string";
import ALlFunc from "@/FuncGlobal/ALlFunc";
// import html2canvas from "html2canvas"


export default {
  name: "ApproveEditProject",
  data() {
    return {
      checkProj1: false,
      checkProj2: false,
      btnDisable: false,
      dateApprove: '',
      Approve_m: null,
      remarksApprove: '',
      TempRecordData: [],
      Approve_Status: [
        {
          id: '1',
          detail: 'รอพิจารณา',
          disable: true
        },
        {
          id: '4',
          detail: 'แก้ไข',
          disable: true
        },
        {
          id: '3',
          detail: 'ไม่อนุมัติ',
          disable: true
        },
        {
          id: '10',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '11',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '2',
          detail: 'อนุมัติ',
          disable: true
        },
      ],
      Req_Approve_Status: [
        {
          id: '2',
          detail: 'ไม่อนุมัติ',
          disable: true
        },
        {
          id: '3',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '4',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '1',
          detail: 'อนุมัติ',
          disable: true
        }
      ],
      CompetencyData: [],
      selection: [],
      TempFileProject: [],
      dialogTempFile: false,
      dialogLoading: false,
      FileProject: [],
      FileProjectOld: [],
      dialogFile: false,
      tab: null,
      approveMasterChoose: [],
      sendApprove: [],
      isMobile: false,
      dialogMasterApprove: false,
      dialogCompetency: false,
      CompetencyToShow: [],
      episode: null,
      inspector: false,
      Master: false,
      Manager: false,
      Owner: false,
      inspector_ro: false,
      Master_ro: false,
      Manager_ro: false,
      Owner_ro: false,
      value: 0,
      download: true,
      CheckPermiss: false,
      Project_code: '',
      dialogTemplate: false,
      dialogApproveForm: false,
      output: null,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      Remark: '',
      Approve: null,
      Remark2: '',
      Approve2: null,
      FiscalYear: '',
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      TemplateProject: 'Project/getTemplateProject',
      Project: 'Project/getProject',
      ProjectFiles: 'Project/getProjectFiles',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      ProjectRound: 'Project/getProjectRound',
      ApproveForm: 'Project/getApproveForm',
      StatusProject: 'Project/getStatusProject',
      TempStatusProject: 'Project/getTempStatusProject',
      TempProject: 'Project/getTempProject',
      TempFiles: 'Project/getTempFiles',
      TempCompetencyProject: 'Project/getTempCompetency',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      MeData: 'Staff/getMeData',
      AdminData: 'Staff/getAdminData',
      ApproveMaster: 'Staff/getApproveMaster',
      AllApproveMaster: 'Staff/getAllApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',


      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
    })
  },
  methods: {
    ...mapActions({
      initTemplateData: 'Project/initTemplateData',
      initProjectDataByCode: 'Project/initProjectDataByCode',
      initProjectFileData: 'Project/initProjectFileData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initApproveFormData: 'Project/initApproveFormData',
      initStatusProject: 'Project/initStatusProject',
      initTempStatusProject: 'Project/initTempStatusProject',
      initTempProjectLimit: 'Project/initTempProjectLimit',
      initTempCompetencyProject: 'Project/initTempCompetencyProject',
      initTempFileProject: 'Project/initTempFileProject',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initMeData2: 'Staff/initMeData2',
      initMeData: 'Staff/initMeData',
      initAdminData: 'Staff/initAdminData',
      initApproveMaster: 'Staff/initApproveMaster',
      initApproveMasterAll: 'Staff/initApproveMasterAll',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',


      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
    }),
    downloadForm() {
      this.$refs.html2Pdf.generatePdf()
    },
    downloadPdf() {
      const doc = new jsPDF();
      const contentHtml = this.$refs.content.innerHTML;
      doc.fromHTML(contentHtml, 15, 15, {
        width: 170
      });
      doc.save("sample.pdf");
    },
    async downloadWithCSS() {
      // this.$refs.html2Pdf.generatePdf()
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
        quality: '0.5'
      }
      this.output = await this.$html2canvas(el, options);


      // /** WITH CSS */
      // var canvasElement = document.createElement('canvas');
      // html2canvas(this.$refs.printMe, { canvas: canvasElement
      // }).then(function (canvas) {
      //   const doc = new jsPDF();
      //   const img = canvas.toDataURL("image/jpeg", 0.5);
      //   doc.addImage(img,'JPEG',0,0);
      //   doc.save("sample.pdf");
      // });
    },
    ShowData(dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    getPermissMenu(type) {
      return new Promise(resolve => {
        this.initApproveMaster({
          perid: this.MeData[0].perid,
        }).then(res => {
          if (res) {
            if (this.ApproveMaster.length > 0) {
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '1').length > 0) {
                this.inspector = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '2').length > 0) {
                this.Master = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '3').length > 0) {
                this.Manager = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '9').length > 0) {
                this.inspector = true
                this.Master = true
                this.Manager = true
                this.Owner = true
              }

              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '1' && item.readonly == '0').length > 0) {
                this.inspector_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '2' && item.readonly == '0').length > 0) {
                this.Master_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '3' && item.readonly == '0').length > 0) {
                this.Manager_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '9' && item.readonly == '0').length > 0) {
                this.inspector_ro = true
                this.Master_ro = true
                this.Manager_ro = true
                this.Owner_ro = true
              }


              this.initApproveMasterAll().then(resApproveAll => {
                if (resApproveAll) {
                  if (this.AllApproveMaster.filter(item => item.perid == this.MeData[0].perid && item.type == type && (item.Approve_Project_Type_Ms == '1' || item.Approve_Project_Type_Ms == '2' || item.Approve_Project_Type_Ms == '3' || item.Approve_Project_Type_Ms == '9')).length > 0) {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = true
                    }, 1000)
                    resolve(true)
                  } else {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = false
                    }, 1000)
                    resolve(true)
                  }
                }
              }).catch(catchApproveAll => {
                if (catchApproveAll) {
                  this.value = 100
                  setTimeout(() => {
                    this.download = false
                    this.CheckPermiss = false
                  }, 1000)
                  resolve(true)
                }
              })
            } else {
              this.value = 100
              setTimeout(() => {
                this.download = false
                this.CheckPermiss = false
              }, 1000)
              resolve(true)
            }
          } else {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
            resolve(true)
          }
        }).catch(res => {
          if (res) {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
            resolve(true)
          }
        })
      })
    },
    init() {
      this.FileProject = []
      this.FileProjectOld = []
      this.episode = null
      this.Approve_m = null
      this.remarksApprove = ''
      if (this.$route.params.ProjectCode != null && this.$route.params.ProjectCode != '') {
        this.Project_code = this.$route.params.ProjectCode
        this.getCompetency()
        this.initProjectDataByCode({
          Project_code: this.$route.params.ProjectCode
        }).then(res => {
          if (res) {
            if (this.Project.length > 0) {
              this.dateApprove = ALlFunc.getDateNow()
              this.getPermissMenu(this.Project[0].Project_category).then(resPer => {
                if (resPer) {
                  this.Project[0].Project_name = this.Project[0].Project_name.replace(/&quot;/g, '"')
                  if ((this.Project[0].DateStart == (parseInt(this.Project[0].FiscalYear) - 1) + '-10-01') && (this.Project[0].DateEnd == (parseInt(this.Project[0].FiscalYear) - 1) + '-12-31')) {
                    this.episode = '1'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-01-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-03-31')) {
                    this.episode = '2'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-04-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-06-30')) {
                    this.episode = '3'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-07-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-09-30')) {
                    this.episode = '4'
                  } else {
                    this.episode = null
                  }

                  if (this.ApproveMaster.length > 0) {
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '1' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '4' || app_i.id == '10') {
                          app_i.disable = false
                        }
                      })
                      this.Req_Approve_Status.map(app_i => {
                        if (app_i.id == '3') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '2' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '3' || app_i.id == '4' || app_i.id == '11') {
                          app_i.disable = false
                        }
                      })
                      this.Req_Approve_Status.map(app_i => {
                        if (app_i.id == '2' || app_i.id == '4') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '3' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '2' || app_i.id == '3' || app_i.id == '4') {
                          app_i.disable = false
                        }
                      })
                      this.Req_Approve_Status.map(app_i => {
                        if (app_i.id == '1' || app_i.id == '2') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '9' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        app_i.disable = false
                      })
                      this.Req_Approve_Status.map(app_i => {
                        app_i.disable = false
                      })
                    }
                  } else {
                    this.Approve_Status.map(app_i => {
                      app_i.disable = true
                    })
                    this.Req_Approve_Status.map(app_i => {
                      app_i.disable = true
                    })
                  }
                }
              })
            }

            this.initApproveFormData({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                if (this.ApproveForm.length > 0) {
                  this.ApproveForm[0].message = this.ApproveForm[0].message.replaceAll('&quot;', '"')
                }
              }
            })
            this.initProjectFileData({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                if (this.ProjectFiles.length > 0) {
                  this.ProjectFiles.map((f_item) => {
                    switch (f_item.File_type) {
                      case 'image/jpg':
                      case 'image/jpeg':
                      case 'image/gif':
                      case 'image/bmp':
                      case 'image/png':
                        this.FileProject.push({
                          ...f_item,
                          name: f_item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                          path: f_item.File_path,
                          type: 'image',
                          type_Img: f_item.File_type
                        })
                        break
                      case 'application/pdf':
                        this.FileProject.push({
                          ...f_item,
                          name: f_item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                          path: f_item.File_path,
                          type: 'pdf',
                          type_Img: f_item.File_type
                        })
                        break
                      default:
                        break
                    }
                  })
                }
              }
              this.FileProjectOld = [...this.FileProject]
            })
            this.initTemplateData({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                if (this.TemplateProject.length > 0) {
                  this.TemplateProject[0].Template = this.TemplateProject[0].Template.replaceAll('&quot;', '"')
                }
              }
            })
            this.initTempProjectLimit({
              Project_code: this.$route.params.ProjectCode
            })
            this.getTempApproveRecord(this.$route.params.ProjectCode)
          }
        })
      } else {
        this.Project_code = ''
      }
    },
    getTempApproveRecord(Project_code) {
      this.TempRecordData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record_view/Project_code/' + Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.TempRecordData = res.data
          } else {
            this.TempRecordData.push(res.data)
          }
        } else {
          this.TempRecordData = []
        }
      })
    },
    showTempCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initTempCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.TempCompetencyProject.length > 0) {
            this.TempCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.dialogCompetency = true
        }
      })
    },
    showTempFile(item) {
      this.dialogTempFile = true
      this.dialogLoading = true
      this.TempFileProject = []
      this.initTempFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.TempFiles.length > 0) {
            this.TempFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    getCompetency() {
      this.selection = []
      this.initProjectCompetencyData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
        }
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initProjectCompetencyData({
        Project_code: item.Project_code
      }).then(resProjCompre => {
        if (resProjCompre) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.Competency_Data.length > 0) {
            this.Competency_Data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })


                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }


                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)


                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }


                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    showFile() {
      this.dialogFile = true
    },
    ApproveData() {
      if (this.Approve == null || this.Approve == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.dialogLoading = true
            var param = null
            var Ref_id_edit = this.getRandomFileName()
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            const headerAxiosUpdate = {
              headers: {
                'Content-Type': 'application/json',
              }
            }


            param = {
              Project_code: this.Project_code,
              Status: this.Approve,
              Remark: this.Remark,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }


            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record/', param, headerAxios).then(res => {
              if (res.data) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/Ref_id/' + this.TempProject[0].Ref_id, {
                  Req_status: this.Approve,
                  Remark: this.Remark,
                  Update_By: this.MeData[0].perid,
                }, headerAxiosUpdate).then(res => {
                  if (res.data) {

                    if (this.Approve == '1') {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.TempProject[0].Project_code, {
                        Project_code: this.TempProject[0].Project_code,
                        Project_name: this.TempProject[0].Project_name,
                        Course_code: this.TempProject[0].Course_code,
                        course_group: this.TempProject[0].course_group,
                        Project_category: this.TempProject[0].Project_category,
                        Project_type: this.TempProject[0].Project_type,
                        WorkBy: this.TempProject[0].WorkBy,
                        WorkByName: this.TempProject[0].WorkByName,
                        WorkByPhone: this.TempProject[0].WorkByPhone,
                        Location: this.TempProject[0].Location,
                        DatePeriod: this.TempProject[0].DatePeriod,
                        DateStart: this.TempProject[0].DateStart,
                        DateEnd: this.TempProject[0].DateEnd,
                        CalHourse: this.TempProject[0].CalHourse,
                        CalCredit: this.TempProject[0].CalCredit,
                        PLACE: this.TempProject[0].PLACE,
                        Province_id: this.TempProject[0].Province_id,
                        Country_id: this.TempProject[0].Country_id,
                        Status: this.TempProject[0].Status,
                        Objective: this.TempProject[0].Objective,
                        TargetGroup: this.TempProject[0].TargetGroup,
                        Remarks: this.TempProject[0].Remarks,
                        ProjectLevel: this.TempProject[0].ProjectLevel,
                        App_doc_no: this.TempProject[0].App_doc_no,
                        BudgetRequest: this.TempProject[0].BudgetRequest,
                        BudgetArrove: this.TempProject[0].BudgetArrove,
                        MoneyDisburse: this.TempProject[0].MoneyDisburse,
                        Project_group: this.TempProject[0].Project_group,
                        Approve: this.TempProject[0].Approve,
                        FiscalYear: this.TempProject[0].FiscalYear,
                        IsPlan: this.TempProject[0].IsPlan,
                        IsPlanStatus: this.TempProject[0].IsPlanStatus,
                        Status_Reg: this.TempProject[0].Status_Reg,
                        Status_Type_Reg: this.TempProject[0].Status_Type_Reg,
                        DateS_Reg: this.TempProject[0].DateS_Reg,
                        DateE_Reg: this.TempProject[0].DateE_Reg,
                        Status_Count_Reg: this.TempProject[0].Status_Count_Reg,
                        Count_Reg: this.TempProject[0].Count_Reg,
                        Dep_Code: this.TempProject[0].Dep_Code,
                        Create_By: this.MeData[0].perid
                      }, {
                        headers: {
                          'Content-Type': 'application/json',
                        }
                      }, headerAxios).then(async res => {
                        if (res.data.status) {
                          const logEdit = await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Edit_Project/', {
                            Ref_id: Ref_id_edit,
                            Create_By: this.MeData[0].perid
                          }, {
                            headers: {
                              'Content-Type': 'application/json',
                              'X-REST-METHOD': 'PUT'
                            }
                          })
                          if (logEdit.data.status) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project/', {
                              Ref_id: Ref_id_edit,
                              Project_code: this.Project[0].Project_code,
                              Project_name: this.Project[0].Project_name,
                              Course_code: this.Project[0].Course_code,
                              course_group: this.Project[0].course_group,
                              Project_category: this.Project[0].Project_category,
                              Project_type: this.Project[0].Project_type,
                              WorkBy: this.Project[0].WorkBy,
                              WorkByName: this.Project[0].WorkByName,
                              WorkByPhone: this.Project[0].WorkByPhone,
                              Location: this.Project[0].Location,
                              DatePeriod: this.Project[0].DatePeriod,
                              DateStart: this.Project[0].DateStart,
                              DateEnd: this.Project[0].DateEnd,
                              CalHourse: this.Project[0].CalHourse,
                              CalCredit: this.Project[0].CalCredit,
                              PLACE: this.Project[0].PLACE,
                              Province_id: this.Project[0].Province_id,
                              Country_id: this.Project[0].Country_id,
                              Status: this.Project[0].Status,
                              Objective: this.Project[0].Objective,
                              TargetGroup: this.Project[0].TargetGroup,
                              Remarks: this.Project[0].Remarks,
                              ProjectLevel: this.Project[0].ProjectLevel,
                              App_doc_no: this.Project[0].App_doc_no,
                              BudgetRequest: this.Project[0].BudgetRequest,
                              BudgetArrove: this.Project[0].BudgetArrove,
                              MoneyDisburse: this.Project[0].MoneyDisburse,
                              Project_group: this.Project[0].Project_group,
                              Approve: this.Project[0].Approve,
                              FiscalYear: this.Project[0].FiscalYear,
                              IsPlan: this.Project[0].IsPlan,
                              IsPlanStatus: this.Project[0].IsPlanStatus,
                              Status_Reg: this.Project[0].Status_Reg,
                              Status_Type_Reg: this.Project[0].Status_Type_Reg,
                              DateS_Reg: this.Project[0].DateS_Reg,
                              DateE_Reg: this.Project[0].DateE_Reg,
                              Status_Count_Reg: this.Project[0].Status_Count_Reg,
                              Count_Reg: this.Project[0].Count_Reg,
                              Dep_Code: this.Project[0].Dep_Code,
                              Create_By: this.MeData[0].perid
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }).then(async resLogD_Project => {
                              if (resLogD_Project.data.status) {
                                const resFile = await this.insertFileData(this.TempProject[0].Project_code, this.TempProject[0].Ref_id)
                                if (resFile) {
                                  const resFileOld = await this.insertLogFileData(this.TempProject[0].Project_code, Ref_id_edit)
                                  if (resFileOld) {

                                    const resAddLogCom = await this.AddLogCompetency2(this.TempProject[0].Project_code, Ref_id_edit)

                                    const resAddCom = resAddLogCom ? await this.AddCompetency2(this.TempProject[0].Project_code, this.TempProject[0].Ref_id) : false

                                    if (resAddCom) {
                                      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                        perid_admin: this.TempProject[0].Create_By,
                                        perid: this.MeData[0].perid,
                                        headerName: 'แจ้งผลการพิจารณา คำขอแก้ไขแผนอนุมัติตั้งงบประมาณประจำปี',
                                        header: this.TempProject[0].Project_name + ' (' + this.TempProject[0].Project_code + ')',
                                        body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอแก้ไขแผน : ' + this.TempProject[0].Project_name + ' (' + this.TempProject[0].Project_code + ')' + ' ' + (this.Approve == '1' ? 'ถูกอนุมัติแล้ว' : this.Approve == '2' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                            '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.Remark + '' +
                                            '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                            '<hr style="margin-top: 50px;">' +
                                            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                                      }), {
                                        headers: {
                                          "Content-Type": "application/x-www-form-urlencoded"
                                        }
                                      })
                                      this.dialogLoading = false
                                      this.dialogMasterApprove = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'พิจารณาโครงการ ' + this.TempProject[0].Project_name + ' สำเร็จ!!'
                                      })
                                      this.init()
                                    } else {
                                      this.dialogLoading = false
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผิดพลาด',
                                        text: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ',
                                      })
                                    }
                                  } else {
                                    this.dialogLoading = false
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติข้อมูลประวัติไฟล์ประกอบเพิ่มเติมได้!!'
                                    })
                                  }
                                } else {
                                  this.dialogLoading = false
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลไฟล์ประกอบเพิ่มเติมได้!!'
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติการแก้ไขข้อมูลได้!!'
                                })
                              }
                            })
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติทำรายการได้!!'
                            })
                          }
                        }
                      })
                    } else {
                      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                        perid_admin: this.TempProject[0].Create_By,
                        perid: this.MeData[0].perid,
                        headerName: 'แจ้งผลการพิจารณา คำขอแก้ไขแผนอนุมัติตั้งงบประมาณประจำปี',
                        header: this.TempProject[0].Project_name,
                        body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอแก้ไขแผน : ' + this.TempProject[0].Project_name + ' ' + (this.Approve == '1' ? 'ถูกอนุมัติแล้ว' : this.Approve == '2' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                            '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.Remark + '' +
                            '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                            '<hr style="margin-top: 50px;">' +
                            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                      }), {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded"
                        }
                      })
                      this.dialogLoading = false
                      this.dialogMasterApprove = false
                      this.$swal.fire({
                        icon: 'success',
                        title: 'พิจารณาโครงการ ' + this.TempProject[0].Project_name + ' สำเร็จ!!'
                      })
                      this.init()
                    }
                  }
                })
              }
            })
          }
        })
      }
    },
    SendNextApprove() {
      if (this.sendApprove.length > 0) {
        this.ConsideReqEditProject(true)
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถทำรายการได้ กรุณาเลือกผู้มีอำนาจอนุมัติ'
        })
      }
    },
    ChooseMasterApprove(typeApprove) {
      this.sendApprove = []
      if (this.Approve_m == '' || (this.dateApprove == '' || this.dateApprove == null)) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else {
        this.approveMasterChoose = []
        this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.TempProject[0].Project_category && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.TempProject[0].Project_type)))
        this.dialogMasterApprove = true
      }
    },
    ApproveDataMaster() {
      if (this.Approve2 == null || this.Approve2 == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
              if (result.value) {
                var param = null
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                const headerAxiosUpdate = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }
                param = {
                  Project_code: this.Project_code,
                  Status: this.Approve2,
                  Remark: this.Remark2,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }


                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record/', param, headerAxios)
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/Ref_id/' + this.TempProject[0].Ref_id, {
                  Req_status: this.Approve2
                }, headerAxiosUpdate).then(res => {
                      if (res.data.status) {
                        if (this.Approve2 == '4') {
                          if (this.AllApproveMaster.length > 0) {
                            this.AllApproveMaster.map(App_item => {
                              for (var i = 0; i <= this.sendApprove.length; i++) {
                                if (App_item.id == this.sendApprove[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
                                  this.SendMail({
                                    headerName: 'แจ้งเตือนการพิจารณาคำร้องขอแก้ไขข้อมูลแผนอนุมัติงบประมาณประจำปี',
                                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">คำร้องขอแก้ไขข้อมูลแผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                    peridToSend: this.MeData[0].perid,
                                    peridToReceive: App_item.perid
                                  })


                                  if (App_item.psu_passport != null && App_item.psu_passport != '') {
                                    this.SendGMail({
                                      email: App_item.psu_passport,
                                      headerName: 'แจ้งเตือนการพิจารณาคำร้องขอแก้ไขข้อมูลแผนอนุมัติงบประมาณประจำปี',
                                      header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                      body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                          '<hr style="margin-top: 50px;">' +
                                          '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                          '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                    })
                                  }
                                }
                              }
                            })
                          }
                        } else {
                          axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                            perid_admin: this.Project[0].Create_By,
                            perid: this.MeData[0].perid,
                            headerName: 'แจ้งผลการพิจารณา คำขอแก้ไขแผนอนุมัติตั้งงบประมาณประจำปี',
                            header: this.Project[0].Project_name,
                            body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอแก้ไขแผน : ' + this.Project[0].Project_name + ' ' + (this.Approve2 == '1' ? 'ถูกอนุมัติแล้ว' : this.Approve2 == '2' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.Remark2 + '' +
                                '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                '<hr style="margin-top: 50px;">' +
                                '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                          }), {
                            headers: {
                              "Content-Type": "application/x-www-form-urlencoded"
                            }
                          })
                        }
                        this.dialogMasterApprove = false
                        this.$swal.fire({
                          icon: 'success',
                          title: 'พิจารณาโครงการ ' + this.Project[0].Project_name + ' สำเร็จ!!'
                        })
                        this.init()
                      } else {
                        this.dialogMasterApprove = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                        })
                      }
                    }
                ).catch(resCatch => {
                  if (resCatch) {
                    this.dialogMasterApprove = false
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                    })
                  }
                })
              }
            }
        )
      }
    },
    AddCompetency2(Project_code, Ref_id) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + Project_code).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + Project_code, {
              active: '0',
              update_by: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json',
              }
            }).then(res => {
              if (res.data.status) {
                this.initTempCompetencyProject({
                  Ref_id: Ref_id
                }).then(res => {
                  if (res) {
                    if (this.TempCompetencyProject.length > 0) {
                      this.TempCompetencyProject.map(tempCom => {
                        this.CompetencyData.map(root => {
                          if (root.children.length > 0) {
                            root.children.map(child1 => {
                              if (child1.children.length > 0) {
                                child1.children.map(child2 => {
                                  if (child2.id == tempCom.DelvNo) {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                      Project_code: Project_code,
                                      DelvNo: child2.DelvNo,
                                      create_by: this.MeData[0].perid,
                                      create_time: 'now()'
                                    }, headerAxiosPUT)
                                  }
                                })
                              }
                              if (child1.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child1.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (root.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: root.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      })
                      resolve(true)
                    } else {
                      resolve(true)
                    }
                  }
                }).catch(res => {
                  if (res) {
                    resolve(true)
                  }
                })
              } else {
                resolve(false)
              }
            })
          } else {
            this.initTempCompetencyProject({
              Ref_id: Ref_id
            }).then(res => {
              if (res) {
                if (this.TempCompetencyProject.length > 0) {
                  this.TempCompetencyProject.map(tempCom => {
                    this.CompetencyData.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == tempCom.DelvNo) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  })
                  resolve(true)
                } else {
                  resolve(true)
                }
              }
            }).catch(res => {
              if (res) {
                resolve(true)
              }
            })
          }
        }).catch(res => {
          if (res) {
            this.initTempCompetencyProject({
              Ref_id: Ref_id
            }).then(res => {
              if (res) {
                if (this.TempCompetencyProject.length > 0) {
                  this.TempCompetencyProject.map(tempCom => {
                    this.CompetencyData.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == tempCom.DelvNo) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  })
                  resolve(true)
                } else {
                  resolve(true)
                }
              }
            }).catch(res => {
              if (res) {
                resolve(true)
              }
            })
          }
        })
      })
    },
    AddLogCompetency2(Project_code, Ref_id) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.selection.length > 0) {
          for (var i = 0; i <= this.selection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                          Ref_id: Ref_id,
                          Project_code: Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                      Ref_id: Ref_id,
                      Project_code: Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.selection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                  Ref_id: Ref_id,
                  Project_code: Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                }, headerAxiosPUT)
              }
            })
          }
          this.selection = []
          resolve(true)
        } else {
          resolve(true)
        }
      })
    },
    insertFileData(Project_code, Ref_id) {
      return new Promise(resolve => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + Project_code, {
          active: '0',
          Update_By: this.MeData[0].perid
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
        this.initTempFileProject({
          Ref_id: Ref_id
        }).then(res => {
          if (res) {
            if (this.TempFiles.length > 0) {
              var Count = 0
              this.TempFiles.map((item) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                  Project_code: Project_code,
                  File_name: item.File_name,
                  File_path: item.File_path,
                  File_type: item.File_type,
                  Type: '0'
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }).then(res => {
                  if (res.data.status) {
                    Count++
                    if (Count == this.TempFiles.length) {
                      resolve(true)
                    }
                  }
                })
              })
            } else {
              resolve(true)
            }
          } else {
            resolve(true)
          }
        }).catch(resCatch => {
          if (resCatch) {
            resolve(true)
          }
        })

      })
    },
    insertLogFileData(Project_code, Ref_id) {
      return new Promise(resolve => {
        if (this.FileProject.length > 0) {
          var countFileProject = 0
          this.FileProject.map((item) => {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_files', {
              Ref_id: Ref_id,
              Project_code: Project_code,
              File_name: item.name,
              File_path: item.path,
              File_type: item.type_Img,
              Type: '0',
              Create_By: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }).then(res => {
              if (res.data.status) {
                countFileProject++
                if (countFileProject == this.FileProject.length) {
                  this.FileProject = []
                  resolve(true)
                }
              } else {
                resolve(false)
              }
            }).catch(resCatch => {
              if (resCatch) {
                resolve(false)
              }
            })
          })
        } else {
          resolve(true)
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    SendMailApprove() {
      this.AllApproveMaster.map(App_item => {
        for (var i = 0; i <= this.sendApprove.length; i++) {
          if (App_item.id == this.sendApprove[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
              perid_admin: App_item.perid,
              perid: this.MeData[0].perid,
              headerName: 'แจ้งเตือนการพิจารณาขอแก้ไขแผนอนุมัติงบประมาณประจำปี ' + this.TempProject[0].Project_name + ' (' + this.TempProject[0].Project_code + ')',
              header: this.TempProject[0].Project_name + ' (' + this.TempProject[0].Project_code + ')',
              body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.TempProject[0].Project_name + ' (' + this.TempProject[0].Project_code + ') ' + (this.Approve_m == '3' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +

                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.TempProject[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                  // '<p style="margin-top: 25px;font-size: 16px;">หรือสามารถเข้าสู้เมนูพิจารณาแผนอนุมัติงานประมาณประจำปีได้ ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนอนุมัติงานประมาณประจำปี </a></p>' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })

            if (this.Approve_m == '4' || this.TempProject[0].Req_status == '4') {
              if (App_item.psu_passport != null && App_item.psu_passport != '') {
                this.SendGMail({
                  email: App_item.psu_passport,
                  headerName: 'แจ้งเตือนการพิจารณาคำร้องขอแก้ไขข้อมูลแผนอนุมัติงบประมาณประจำปี',
                  header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                })
              }
              this.SendGMail({
                email: 'thawatchai.j@psu.ac.th',
                headerName: '(สำเนา) แจ้งเตือนการพิจารณาคำร้องขอแก้ไขข้อมูลแผนอนุมัติงบประมาณประจำปี',
                header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                    '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
              })
              if (this.Project[0].Project_category == '1') {
                this.SendGMail({
                  email: 'hrdalert2u@gmail.com',
                  headerName: '(สำเนา) แจ้งเตือนการพิจารณาคำร้องขอแก้ไขข้อมูลแผนอนุมัติงบประมาณประจำปี',
                  header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                })
              }
            }
          }
        }
      })
    },
    ConsideReqEditProject(sendmail) {
      if (this.Approve_m == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            var paramRecord = null
            var Ref_id_edit = this.getRandomFileName()
            this.dialogLoading = true
            this.btnDisable = true
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            const headerAxiosUpdate = {
              headers: {
                'Content-Type': 'application/json',
              }
            }

            param = {
              Req_status: this.Approve_m,
              Remark: this.remarksApprove,
              Update_By: this.MeData[0].perid,
            }
            paramRecord = {
              Project_code: this.Project_code,
              Status: this.Approve_m,
              Remark: this.remarksApprove,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }
            if (sendmail) {
              this.SendMailApprove()
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record/', paramRecord, headerAxios)
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/id/' + this.TempProject[0].temp_id, param, headerAxiosUpdate).then(res => {
              if (res.data) {
                if (this.Approve_m == '1') {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.TempProject[0].Project_code, {
                    Project_code: this.TempProject[0].Project_code,
                    Project_name: this.TempProject[0].Project_name,
                    Course_code: this.TempProject[0].Course_code,
                    course_group: this.TempProject[0].course_group,
                    IsProcess: this.TempProject[0].IsProcess,
                    Project_category: this.TempProject[0].Project_category,
                    Project_type: this.TempProject[0].Project_type,
                    WorkBy: this.TempProject[0].WorkBy,
                    WorkByName: this.TempProject[0].WorkByName,
                    WorkByPhone: this.TempProject[0].WorkByPhone,
                    Location: this.TempProject[0].Location,
                    DatePeriod: this.TempProject[0].DatePeriod,
                    DateStart: this.TempProject[0].DateStart,
                    DateEnd: this.TempProject[0].DateEnd,
                    CalHourse: this.TempProject[0].CalHourse,
                    CalCredit: this.TempProject[0].CalCredit,
                    PLACE: this.TempProject[0].PLACE,
                    Province_id: this.TempProject[0].Province_id,
                    Country_id: this.TempProject[0].Country_id,
                    Status: this.TempProject[0].Status,
                    Objective: this.TempProject[0].Objective,
                    TargetGroup: this.TempProject[0].TargetGroup,
                    Remarks: this.TempProject[0].Remarks,
                    ProjectLevel: this.TempProject[0].ProjectLevel,
                    App_doc_no: this.TempProject[0].App_doc_no,
                    BudgetRequest: this.TempProject[0].BudgetRequest,
                    BudgetArrove: this.TempProject[0].BudgetArrove,
                    MoneyDisburse: this.TempProject[0].MoneyDisburse,
                    Project_group: this.TempProject[0].Project_group,
                    Approve: this.TempProject[0].Approve,
                    FiscalYear: this.TempProject[0].FiscalYear,
                    IsPlan: this.TempProject[0].IsPlan,
                    IsPlanStatus: this.TempProject[0].IsPlanStatus,
                    Status_Reg: this.TempProject[0].Status_Reg,
                    Status_Type_Reg: this.TempProject[0].Status_Type_Reg,
                    DateS_Reg: this.TempProject[0].DateS_Reg,
                    DateE_Reg: this.TempProject[0].DateE_Reg,
                    Status_Count_Reg: this.TempProject[0].Status_Count_Reg,
                    Count_Reg: this.TempProject[0].Count_Reg,
                    Dep_Code: this.TempProject[0].Dep_Code,
                    Create_By: this.MeData[0].perid
                  }, {
                    headers: {
                      'Content-Type': 'application/json',
                    }
                  }, headerAxios).then(async res => {
                    if (res.data.status) {
                      const logEdit = await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Edit_Project/', {
                        Ref_id: Ref_id_edit,
                        Create_By: this.MeData[0].perid
                      }, {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      })
                      if (logEdit.data.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project/', {
                          Ref_id: Ref_id_edit,
                          Project_code: this.Project[0].Project_code,
                          Project_name: this.Project[0].Project_name,
                          Course_code: this.Project[0].Course_code,
                          course_group: this.Project[0].course_group,
                          IsProcess: this.Project[0].IsProcess,
                          Project_category: this.Project[0].Project_category,
                          Project_type: this.Project[0].Project_type,
                          WorkBy: this.Project[0].WorkBy,
                          WorkByName: this.Project[0].WorkByName,
                          WorkByPhone: this.Project[0].WorkByPhone,
                          Location: this.Project[0].Location,
                          DatePeriod: this.Project[0].DatePeriod,
                          DateStart: this.Project[0].DateStart,
                          DateEnd: this.Project[0].DateEnd,
                          CalHourse: this.Project[0].CalHourse,
                          CalCredit: this.Project[0].CalCredit,
                          PLACE: this.Project[0].PLACE,
                          Province_id: this.Project[0].Province_id,
                          Country_id: this.Project[0].Country_id,
                          Status: this.Project[0].Status,
                          Objective: this.Project[0].Objective,
                          TargetGroup: this.Project[0].TargetGroup,
                          Remarks: this.Project[0].Remarks,
                          ProjectLevel: this.Project[0].ProjectLevel,
                          App_doc_no: this.Project[0].App_doc_no,
                          BudgetRequest: this.Project[0].BudgetRequest,
                          BudgetArrove: this.Project[0].BudgetArrove,
                          MoneyDisburse: this.Project[0].MoneyDisburse,
                          Project_group: this.Project[0].Project_group,
                          Approve: this.Project[0].Approve,
                          FiscalYear: this.Project[0].FiscalYear,
                          IsPlan: this.Project[0].IsPlan,
                          IsPlanStatus: this.Project[0].IsPlanStatus,
                          Status_Reg: this.Project[0].Status_Reg,
                          Status_Type_Reg: this.Project[0].Status_Type_Reg,
                          DateS_Reg: this.Project[0].DateS_Reg,
                          DateE_Reg: this.Project[0].DateE_Reg,
                          Status_Count_Reg: this.Project[0].Status_Count_Reg,
                          Count_Reg: this.Project[0].Count_Reg,
                          Dep_Code: this.Project[0].Dep_Code,
                          Create_By: this.MeData[0].perid
                        }, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(async resLogD_Project => {
                          if (resLogD_Project.data.status) {
                            const resFile = await this.insertFileData(this.TempProject[0].Project_code, this.TempProject[0].Ref_id)
                            if (resFile) {
                              const resFileOld = await this.insertLogFileData(this.TempProject[0].Project_code, Ref_id_edit)
                              if (resFileOld) {

                                const resAddLogCom = await this.AddLogCompetency2(this.TempProject[0].Project_code, Ref_id_edit)

                                const resAddCom = resAddLogCom ? await this.AddCompetency2(this.TempProject[0].Project_code, this.TempProject[0].Ref_id) : false

                                if (resAddCom) {
                                  axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                    perid_admin: this.TempProject[0].Create_By,
                                    perid: this.MeData[0].perid,
                                    headerName: 'แจ้งผลการพิจารณา คำขอแก้ไขแผนอนุมัติตั้งงบประมาณประจำปี',
                                    header: this.TempProject[0].Project_name,
                                    body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอแก้ไขแผน : ' + this.TempProject[0].Project_name + ' ' + (this.Approve_m == '1' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '2' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                                  }), {
                                    headers: {
                                      "Content-Type": "application/x-www-form-urlencoded"
                                    }
                                  })
                                  this.dialogLoading = false
                                  this.btnDisable = false
                                  this.dialogMasterApprove = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.init()
                                  this.Details_Cordi = false

                                  this.btnDisable = false

                                  this.e1 = '1'

                                  this.Process = '1'
                                  this.Project_code = ''
                                  this.Project_name = ''
                                  this.Course_code = '0000000'
                                  this.course_group = ''
                                  this.Project_type = ''
                                  this.IsProcess = null
                                  this.Project_category = null
                                  this.Remarks = ''
                                  this.WorkBy = ''
                                  this.Location = ''
                                  this.DateStart = ''
                                  this.DateEnd = ''
                                  this.CalHourse = '0'
                                  this.CalCredit = '0'
                                  this.PLACE = ''
                                  this.Province_id = ''
                                  this.BudgetRequest = ''
                                  this.ChooseTypeDep = '0'
                                  this.ChooseTypRegis = '1'
                                  this.ChooseTypRegis2 = '0'
                                  this.dateRegStart = ''
                                  this.dateRegEnd = ''
                                  this.ProjectQuotaCount = ''
                                  this.ProjectQuotaDepCount = 0
                                  this.MessageSuc = ''
                                  this.MessageError = ''
                                  this.ChkJoinPerson = true
                                  this.ShowAlertErr = false
                                  this.ShowAlertSuc = false
                                  this.Project_group = ''
                                  this.DepSelect = ''
                                  this.Period_code = ''
                                  this.editorData = ''
                                  this.FiscalYear = ''
                                  this.IsPlan = null
                                  this.IsPlanStatus = ''
                                  this.WorkByName = ''
                                  this.WorkByPhone = ''
                                  this.itemCode = ''
                                  this.txtAlert = []
                                  this.alert = false
                                } else {
                                  this.dialogLoading = false
                                  this.btnDisable = false
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด',
                                    text: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ',
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.btnDisable = false
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติข้อมูลประวัติไฟล์ประกอบเพิ่มเติมได้!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.btnDisable = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลไฟล์ประกอบเพิ่มเติมได้!!'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.btnDisable = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติการแก้ไขข้อมูลได้!!'
                            })
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.btnDisable = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติทำรายการได้!!'
                        })
                      }
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.btnDisable = false
                  this.dialogMasterApprove = false
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })
                  this.init()
                  this.Details_Cordi = false
                  this.btnDisable = false
                }
              }
            })
          }
        })
      }
    },
    backToMenu() {
      this.$router.push('/BudgetProject')
    }
  },
  mounted() {
    this.initStatusProject()
    this.initTempStatusProject()
    this.initProjectGroupData()
    this.initCountryData()
    this.initCourseData()
    this.initCompetencyData().then(res => {
      if (res) {
        this.Competency.map(compe_i => {
          if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
            if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
              this.CompetencyData.push({
                ...compe_i,
                id: compe_i.DelvNo,
                name: compe_i.DelvDes,
                DelvLevel: '0',
                checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                children: []
              })
            } else {
              this.CompetencyData.push({
                ...compe_i,
                id: compe_i.DelvNo,
                name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                DelvLevel: '0',
                checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                children: []
              })
            }
          }
        })
        this.CompetencyData.map((data_i, idx) => {
          if (data_i.children.length == 0) {
            this.Competency.map(compe_i => {
              if (data_i.DelvNo == compe_i.DelvCover) {
                if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                  this.CompetencyData[idx].children.push({
                    ...compe_i,
                    id: compe_i.DelvNo,
                    name: compe_i.DelvDes,
                    DelvLevel: '1',
                    checkCordi: false,
                    children: []
                  })
                } else {
                  this.CompetencyData[idx].children.push({
                    ...compe_i,
                    id: compe_i.DelvNo,
                    name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                    DelvLevel: '1',
                    checkCordi: false,
                    children: []
                  })
                }
              }
            })
          }
        })
        // lv2
        this.CompetencyData.map(data_i => {
          if (data_i.children.length > 0) {
            data_i.children.map((child1_i, idx) => {
              if (child1_i.children.length == 0) {
                this.Competency.map(compe_i => {
                  if (child1_i.DelvNo == compe_i.DelvCover) {
                    if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                      data_i.children[idx].children.push({
                        ...compe_i,
                        id: compe_i.DelvNo,
                        name: compe_i.DelvDes,
                        DelvLevel: '2',
                        checkCordi: false,
                        children: []
                      })
                    } else {
                      data_i.children[idx].children.push({
                        ...compe_i,
                        id: compe_i.DelvNo,
                        name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                        DelvLevel: '2',
                        checkCordi: false,
                        children: []
                      })
                    }

                  }
                })
              }
            })
          }
        })
      }
    })

/*    this.initMeData2({
      path: 'ApproveProject/' + this.$route.params.ProjectCode
    }).then(res => {
      if (res) {
        this.value = 50
        this.initApproveMaster({
          perid: this.MeData[0].perid,
        }).then(res => {
          if (res) {
            if (this.ApproveMaster.length > 0) {
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '1').length > 0) {
                this.inspector = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '2').length > 0) {
                this.Master = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '3').length > 0) {
                this.Manager = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '9').length > 0) {
                this.inspector = true
                this.Master = true
                this.Manager = true
              }


              this.initApproveMasterAll().then(resApproveAll => {
                if (resApproveAll) {
                  if (this.AllApproveMaster.filter(item => item.perid == this.MeData[0].perid && (item.Approve_Project_Type_Ms == '2' || item.Approve_Project_Type_Ms == '3' || item.Approve_Project_Type_Ms == '9')).length > 0) {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = true


                      this.initDepartData().then(res => {
                        if (res) {
                          this.init()
                        }
                      })
                    }, 1000)
                  } else {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = false
                    }, 1000)
                  }
                }
              }).catch(catchApproveAll => {
                if (catchApproveAll) {
                  this.value = 100
                  setTimeout(() => {
                    this.download = false
                    this.CheckPermiss = false
                  }, 1000)
                }
              })
            } else {
              this.value = 100
              setTimeout(() => {
                this.download = false
                this.CheckPermiss = false
              }, 1000)
            }
          } else {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
          }
        }).catch(res => {
          if (res) {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
          }
        })
      }
    })*/
    this.initMeData().then(res => {
      if (res) {
        this.value = 50
        this.initApproveMaster({
          perid: this.MeData[0].perid,
        }).then(res => {
          if (res) {
            if (this.ApproveMaster.length > 0) {
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '1').length > 0) {
                this.inspector = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '2').length > 0) {
                this.Master = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '3').length > 0) {
                this.Manager = true
              }
              if (this.ApproveMaster.filter(item => item.Approve_Project_Type_Ms == '9').length > 0) {
                this.inspector = true
                this.Master = true
                this.Manager = true
              }

              this.checkProj1 = this.ApproveMaster.filter(appItem => appItem.project_type == '1' || appItem.project_type == '3').length > 0 ? true : false
              this.checkProj2 = this.ApproveMaster.filter(appItem => appItem.project_type == '2' || appItem.project_type == '3').length > 0 ? true : false


              this.initApproveMasterAll().then(resApproveAll => {
                if (resApproveAll) {
                  if (this.AllApproveMaster.filter(item => item.perid == this.MeData[0].perid && (item.Approve_Project_Type_Ms == '2' || item.Approve_Project_Type_Ms == '3' || item.Approve_Project_Type_Ms == '9')).length > 0) {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = true


                      this.initDepartData().then(res => {
                        if (res) {
                          this.init()
                        }
                      })
                    }, 1000)
                  } else {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = false
                    }, 1000)
                  }
                }
              }).catch(catchApproveAll => {
                if (catchApproveAll) {
                  this.value = 100
                  setTimeout(() => {
                    this.download = false
                    this.CheckPermiss = false
                  }, 1000)
                }
              })
            } else {
              this.value = 100
              setTimeout(() => {
                this.download = false
                this.CheckPermiss = false
              }, 1000)
            }
          } else {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
          }
        }).catch(res => {
          if (res) {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>


<style scoped>
/*@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');*/


@font-face {
  font-family: "THSarabunNew";
  src: url('../lib/font/THSarabunNew.ttf');
}


@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url('../lib/font/THSarabunNew Bold.ttf');
}


.pdf-content {
  width: 100%;
  background: #fff;
}


strong {
  font-family: "THSarabunNew";
  font-weight: bold;
}


p {
  font-family: "THSarabunNew";
  font-size: 22px;
}


ul {
  font-family: "THSarabunNew";
  font-size: 22px;
}


ol {
  font-family: "THSarabunNew";
  font-size: 22px;
}


i {
  font-family: "THSarabunNew";
  font-size: 22px;
}


s {
  font-family: "THSarabunNew";
  font-size: 22px;
}


@media print {
  .no-print {
    display: none !important;
  }
}


@media screen {
  .no-screen {
    display: none !important;
  }
}


.v-label {
  color: black;
}


.v-card {
  border: 1px solid;
}


.v-text-field >>> input {
  color: black;
}


.v-text-field >>> label {
  color: black;
  font-weight: bold;
}


.v-text-field >>> button {
  font-size: 0.1em;
}


.ck-content {
  height: 500px;
}


.ck-editor__editable {
  min-height: 500px;
}


textarea {
  font-family: THSarabunNew;
  font-size: 24px;
}
</style>
